import { Lightbulb, X } from "lucide-react";
import { useState } from "react";

export function HandwritingTips() {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="bg-neon-blue/5 border border-neon-blue/20 rounded-xl p-4 space-y-2 relative">
      <button
        onClick={() => setDismissed(true)}
        className="absolute top-2 right-2 size-6 rounded-full flex items-center justify-center text-ink-muted hover:text-ink transition-colors"
      >
        <X className="size-3.5" />
      </button>
      <div className="flex items-center gap-2">
        <Lightbulb className="size-4 text-neon-blue" />
        <span className="text-xs font-bold uppercase tracking-widest text-ink-muted">
          Handwriting Tips
        </span>
      </div>
      <ul className="text-xs text-ink-muted space-y-1.5 pl-6">
        <li className="list-disc">Write on <span className="font-semibold text-ink">blank white paper</span> for best results</li>
        <li className="list-disc">Use a <span className="font-semibold text-ink">dark pen or marker</span> (avoid pencil)</li>
        <li className="list-disc">Write <span className="font-semibold text-ink">large and clearly</span> — spread out equations</li>
        <li className="list-disc">Ensure <span className="font-semibold text-ink">good lighting</span> with no shadows</li>
        <li className="list-disc">Hold camera <span className="font-semibold text-ink">directly above</span> the paper (no angle)</li>
        <li className="list-disc">Use <span className="font-semibold text-ink">"Read Text First"</span> to verify before solving</li>
      </ul>
    </div>
  );
}
